// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__22OUg","footer":"ModalError_footer__1OeNQ"};